import React from "react";
import Input from "../../../../Components/Common/Input";
import Selector from "../../../../Components/Common/Selector";
import useSWR from "swr";
import { CategoryApiUrls } from "../../../../Api/Auth/ApiUrls";

const ModelTestForm = ({ onChange, handleSubmit, errors, formData }) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);
  // Extract hours and minutes from formData.duration (if exists)
  const [hours, minutes] = formData.duration?.split(":") || ["", ""];

  // Handle hours and minutes change
  const handleTimeChange = (name, value) => {
    // Ensure valid input (only numbers)
    if (!/^\d*$/.test(value)) return;

    // Restrict minutes to 0-59
    if (name === "minutes" && (value > 59 || value.length > 2)) return;

    // Update formData.duration as "HH:MM"
    const newTime =
      name === "hours"
        ? `${value}:${minutes || "00"}`
        : `${hours || "0"}:${value}`;
    onChange("duration", newTime);
  };
  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter sub topic title"
          error={errors.title}
          required
        />
        <Input
          label="Description"
          type="text"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Enter description"
          error={errors.description}
        />
        <Selector
          name="category"
          label="Category"
          value={formData?.category}
          options={data?.data?.map((item) => ({
            label: item.title,
            value: item._id,
          }))}
          isClearable={false}
          onChange={onChange}
          error={errors?.category}
          isLoading={isLoading}
          required
        />
        <Input
          label="Price"
          type="number"
          name="price"
          value={formData.price}
          onChange={onChange}
          placeholder="Enter price"
          error={errors.price}
          required
        />
        <Input
          label="Max Attempt(s)"
          type="number"
          name="maxAttempts"
          value={formData.maxAttempts}
          onChange={onChange}
          placeholder="Enter max attempts"
          error={errors.maxAttempts}
          required
        />
        <div className="flex gap-2">
          <Input
            label="Hours"
            type="number"
            name="hours"
            value={hours}
            onChange={handleTimeChange}
            placeholder="HH"
            min={0}
            error={errors.duration}
            required
          />
          <Input
            label="Minutes"
            type="number"
            name="minutes"
            value={minutes}
            onChange={handleTimeChange}
            placeholder="MM"
            min={0}
            max={59}
            error={errors.duration}
            required
          />
        </div>
      </form>
    </>
  );
};

export default ModelTestForm;
